__turbopack_context__.v({
  "className": "gabarito_e2479fd2-module__fWtlQq__className",
  "variable": "gabarito_e2479fd2-module__fWtlQq__variable",
});
